import type { TestimonialProps } from '@pflegia/ui/shared/testimonial';

import { EmployerLogo } from '../components/employers/Employers';
import { VideoObject } from '../components/how-it-works/HowItWorks';
import type { OfferedValuesProps } from '../components/offered-values';

export const ADVANTAGES = ['free', 'discreet', 'fastEasy', 'variety'];

/**
 * Used for filenames and translation keys.
 */
export const CARE_TYPES = ['hospital', 'nursingHome', 'ambulantCare', 'intensive', 'leasing', 'doctorOffice', 'dentalPractice'];

export const TESTIMONIALS: Pick<TestimonialProps, 'name' | 'videoId' | 'alt'>[] = [
  {
    name: 'Astrid',
    videoId: '2r5BtDZmafY',
    alt: 'Video ansehen - Krankenschwester',
  },
  {
    name: 'Julia',
    videoId: '1EWjyVDjkeA',
    alt: 'Video ansehen - Stellenangebote Pflege',
  },
  {
    name: 'Valentina',
    videoId: 'j6-kZCz1zag',
    alt: 'Video ansehen - examinierte Gesundheits- und Krankenpflegerin',
  },
  {
    name: 'Tina',
    videoId: 'k8UZseD2cmI',
    alt: 'Video ansehen - Krankenschwester',
  },
  {
    name: 'Julia',
    videoId: '7b0qa0BqM3w',
    alt: 'Video ansehen - Krankenschwester',
  },
  {
    name: 'Sonja',
    videoId: 'kx1px4sDCw8',
    alt: 'Video ansehen - Stellenangebote Pflege',
  },
];

export const OFFERED_VALUES: OfferedValuesProps['values'] = [
  {
    key: 'effective',
    videoId: '7b0qa0BqM3w',
    alt: 'Video ansehen - Krankenschwester',
    altIconText: 'Krankenpfleger - Stellenangebote Pflege',
  },
  {
    key: 'informative',
    videoId: 'M6VjQiKBf1o',
    alt: 'Video ansehen - Krankenschwester',
    altIconText: 'Krankenpfleger - Stellenangebote Pflege',
  },
  {
    key: 'convenient',
    videoId: 'v4dez6IUiew',
    alt: 'Video ansehen - Krankenschwester',
    altIconText: 'Srankenpfleger - Stellenangebote Pflege',
  },
  {
    key: 'quality',
    videoId: '2r5BtDZmafY',
    alt: 'Video ansehen - Jobs in der Pflege',
    altIconText: 'Krankenpfleger - Stellenangebote Pflege',
  },
];

/**
 * heading and content values must match the keys in the translations file
 * under questionsAndAnswers section
 */
export const COMMON_QUESTIONS_AND_ANSWERS: string[] = ['whyPflegia', 'isFreeOfCharge', 'canOthersSeeMe', 'howPflegiaWork'];

export const PFLEGIA_FAQ = [...COMMON_QUESTIONS_AND_ANSWERS, 'pflegiaHaveJobs'];

export const EMPLOYER_LOGOS: EmployerLogo[] = [
  { src: '/assets/employers/employer1.png', title: 'Caritas - Pflegia' },
  { src: '/assets/employers/employer2.png', title: 'Die Johanniter - Pflegia' },
  { src: '/assets/employers/employer3.png', title: 'Asklepios - Pflegia' },
  { src: '/assets/employers/employer4.png', title: 'Schön Klinik - Pflegia' },
  { src: '/assets/employers/employer5.png', title: 'Bayerisches Rotes Kreuz' },
  { src: '/assets/employers/employer7.png', title: 'Parität - Pflegia' },
  { src: '/assets/employers/employer8.png', title: 'Bremer Heimstiftung - Pflegia' },
  { src: '/assets/employers/employer9.png', title: 'Alloheim - Pflegia' },
  { src: '/assets/employers/employer10.png', title: 'Hoftbauer Stiftung - Pflegia' },
  { src: '/assets/employers/employer11.png', title: 'Residenz-Gruppe - Pflegia' },
  { src: '/assets/employers/employer12.png', title: 'VKKD - Pflegia' },
  { src: '/assets/employers/employer13.png', title: 'AWO - Pflegia' },
  { src: '/assets/employers/employer14.png', title: 'Helios Kliniken - Pflegia' },
  { src: '/assets/employers/employer15.png', title: 'Marienstift - Pflegia' },
  { src: '/assets/employers/employer16.png', title: 'Münchenstift - Pflegia' },
  { src: '/assets/employers/employer17.png', title: 'Jogannesstift Diakonie - Pflegia' },
  { src: '/assets/employers/employer18.png', title: 'Katharinenhof - Pflegia' },
  { src: '/assets/employers/employer19.png', title: 'Paracelsus - Pflegia' },
  { src: '/assets/employers/employer20.png', title: 'K&S Gruppe - Pflegia' },
  { src: '/assets/employers/employer21.png', title: 'ASB - Pflegia' },
  { src: '/assets/employers/employer22.png', title: 'Spiravita - Pflegia' },
  { src: '/assets/employers/employer23.png', title: 'Agaplesion - Pflegia' },
  { src: '/assets/employers/employer24.png', title: 'BG Klinik - Pflegia' },
];

export const SEARCH_FLOW_STEPS = ['selectYourField', 'pickTheBestJob', 'getJobInvites', '24hResponse'];

// TODO: check for proper videos and thumbnails
export const HOW_IT_WORKS_VIDEO: VideoObject = { thumbnail: '/assets/video-thumbnails/KpSgznjpQhY.jpg', id: 'KpSgznjpQhY' };
